<template>
  <router-view
    :progress="progress"
    :handle-next-event="goToNextOrCompleteQuestionnaire"
    @back="goToPreviousRoute"
  />
</template>

<script setup>
import ROUTE from '@shared/modules/assessment/router/names'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import env from '@shared/env.js'
import useAssessmentStore from '@shared/modules/assessment/stores/useAssessmentStore.js'

const route = useRoute()
const router = useRouter()
const assessmentStore = useAssessmentStore()

const steps = {
  msk: [
    ROUTE.ASSESSMENT_SELF_TEST_WELCOME,
    ROUTE.ASSESSMENT_SELF_TEST_ABOUT,
    ROUTE.ASSESSMENT_SELF_TEST_WORST_PAIN_LOCATION,
    ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
    ROUTE.ASSESSMENT_SELF_TEST_PAIN_DURATION,
    ROUTE.ASSESSMENT_SELF_TEST_ACTIVITIES,
    ROUTE.ASSESSMENT_SELF_TEST_FEAR_OF_MOVEMENT,
    ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_MSK,
    ROUTE.ASSESSMENT_SELF_TEST_COMPLETE,
  ],
  copd: [
    ROUTE.ASSESSMENT_SELF_TEST_WELCOME,
    ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_COPD,
    ROUTE.ASSESSMENT_SELF_TEST_ABOUT,
    ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
    ROUTE.ASSESSMENT_SELF_TEST_ACTIVITIES,
  ],
}[env.VITE_DISEASE]

const progress = computed(() => {
  const currentStep = Math.max(
    0,
    steps.findIndex((step) => step === route.name),
  )
  return currentStep / steps.length
})

const getRouteProperties = (modifier) => {
  const index = steps.indexOf(route.name) + modifier

  if (typeof index !== 'number' || index < 0 || index >= steps.length) {
    throw new Error(
      `selfTestNavigation Mixin: Route cannot be determined because the target index is out of bounds. Current route name: ${route.name}, modifier: ${modifier}, target index: ${index}`,
    )
  }

  return { name: steps[index] }
}

const goToNextOrCompleteQuestionnaire = async () => {
  try {
    let routeProperties = getRouteProperties(+1)
    await router.push(routeProperties)
  } catch {
    // complete questionnaires;
    await assessmentStore.completeQuestionnaire(router)
  }
}

const goToPreviousRoute = () => {
  let routeProperties = getRouteProperties(-1)
  router.push(routeProperties)
}
</script>
